import { FlowDescriptor } from 'shared/api/requests/instagram/schemas'

const hasTriggerActive = (flow: FlowDescriptor) =>
  Object.values(flow.widgets).some((w) => w.status === 'active')

export const pickBestFlow = (flows: FlowDescriptor[]): FlowDescriptor | null => {
  if (flows.length === 0) {
    return null
  }

  return flows.toSorted((flowA, flowB) => {
    const isEasyBuilderA = flowA.flow_type === 'easy_builder' ? 1 : 0
    const isEasyBuilderB = flowB.flow_type === 'easy_builder' ? 1 : 0

    if (isEasyBuilderB !== isEasyBuilderA) {
      return isEasyBuilderB - isEasyBuilderA
    }

    const isActiveA = hasTriggerActive(flowA) ? 1 : 0
    const isActiveB = hasTriggerActive(flowB) ? 1 : 0

    if (isActiveB !== isActiveA) {
      return isActiveB - isActiveA
    }

    return parseFloat(flowB.updated_at ?? '0') - parseFloat(flowA.updated_at ?? '0')
  })[0]
}
